import React, { forwardRef } from 'react'
import TextField from '@mui/material/TextField'

export const CustomPhoneInput = forwardRef(({ value, onChange, ...rest }, ref) => {
  return <TextField value={value} onChange={onChange} inputRef={ref} {...rest} />
})
